import React from "react";
import { getWindow } from "ssr-window";

import { api } from "../../utils/api";
import { withTranslation } from "react-i18next";

import ArticleItem from "@/react-components/ArticleItem";
import EmptyResult from "@/react-components/EmptyResult";
import Pagination from "@/react-components/Pagination";
import BackButton from "@/react-components/BackButton";
import { reportTypeEnum } from "@/utils/enum";
import { setUrlParameter, getUrlParameter } from "@/utils";

class RelatedArticleSection extends React.Component {
  constructor(props) {
    super(props);

    const urlParams = getUrlParameter(props?.router?.location?.search)
    this.state = {
      pageParams: {
        pageNo: getWindow()?.history?.state?.params?.pageNo || 1,
        pageSize: 10,
        totalPage: 1,
        itemId:
          getWindow()?.history?.state?.params?.itemId ||
          props?.router?.location?.state?.itemId ||
          urlParams?.itemId,
        reportType:
          getWindow()?.history?.state?.params?.reportType ||
          props?.router?.location?.state?.reportType ||
          urlParams?.reportType
      },
      // 検索結果の保存
      articles: undefined,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    const { pageParams } = this.state;
    const state = getWindow()?.history?.state || {};
    state.params = pageParams;
    getWindow().history.replaceState(state, "");
    const name =
      pageParams.reportType === reportTypeEnum.research ? "report" : "library";
    api[name]
      .related({
        pageIndex: pageParams.pageNo,
        pageSize: pageParams.pageSize,
        itemId: pageParams.itemId,
      })
      .then((response) => {
        pageParams.totalPage = parseInt(
          (response.totalCount + pageParams.pageSize - 1) / pageParams.pageSize
        );
        this.setState({
          pageParams,
          articles: response.list,
        });
        if (response.list.length === 0) {
          setUrlParameter({ type: "noResult" });
        } else {
          setUrlParameter({
            page: pageParams.pageNo,
            reportType: pageParams.reportType,
            itemId: pageParams.itemId
          });
        }
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  pageChange = (page) => {
    const { pageParams } = this.state;
    pageParams.pageNo = page;
    this.setState({ pageParams }, () => {
      this.fetchData();
    });
  };

  render() {
    const { t } = this.props;
    const {
      articles,
      pageParams: { totalPage, pageNo, reportType },
    } = this.state;
    return (
      <section>
        <BackButton />
        <h3
          className={`page-title-text ${
            reportType === reportTypeEnum.research
              ? "news-page-title"
              : "library-related-page-title"
          }`}
        >
          {t("TCMS01011_related")}
        </h3>
        {articles && (
          <React.Fragment>
            {/* リサーチ情報の内容 */}
            <div className="news-section-content">
              {articles.map((item, index) => (
                <ArticleItem key={index} articles={item} />
              ))}
            </div>
            {/* 改ページ */}
            {articles.length > 0 ? (
              <div className="pagination-container">
                <Pagination
                  totalPage={totalPage}
                  pageIndex={pageNo}
                  onChange={this.pageChange}
                />
              </div>
            ) : (
              <EmptyResult />
            )}
          </React.Fragment>
        )}
      </section>
    );
  }
}

export default withTranslation()(RelatedArticleSection);
